import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { SearchState } from '.';

const STATES = [
  SearchState
];

@NgModule({
  imports: [
    NgxsModule.forFeature(STATES)
  ]
})
export class SearchStateModule { }
